import { Injectable } from '@angular/core';
import * as momenttz from 'moment-timezone';
import * as lodash from 'lodash';
import { Subject, empty } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class EventoperationsService {

  refresh: Subject<any> = new Subject();

  constructor() { }


  public getEventsbyDay(events, newstrat) {

    const dayEvents = events.filter((item) => {
      if (momenttz(item.start).isSame(newstrat, 'day') && item.type !== 'holiday' && item.title !== '') {
        return item;
      }

    });
    return dayEvents;
  }

  public geteventsByRange(events, Fromdate, ToDate) {
    const rangeEvents = events.filter((item) => {

      if (momenttz(item.start).isBetween(ToDate, Fromdate) && item.type !== 'holiday') {
        return item;

      }
    });

    return rangeEvents;
  }


  public darzalexBeforeEvents(events, newStartDate) {
    let beforeSameEventDarz;
    // const beforeSameEventvelc;
    // const concatDrugs;
    beforeSameEventDarz = events.filter((item) => {
      const uuid = item['uuid'].slice(item['uuid'].indexOf('D')).substring(0, 4);

      if (uuid === 'Darz' && (newStartDate > item.start)) {
        return item.start;
      } else {
        // console.log("hello1") ;
      }
    });
    return beforeSameEventDarz;
  }

  public valcadeBeforeEvents(events, newStartDate) {
    let beforeSameEventDarz;
    // const beforeSameEventvelc;
    // const concatDrugs;
    beforeSameEventDarz = events.filter((item) => {
      if (item.title === 'Velcade ®' && newStartDate > item.start) {

        return item.start;
      }
    });
    return beforeSameEventDarz;
  }


  public blockofdrugs(events, event) {
    const backwardFilterBlockDrugs = lodash.filter(events, lodash.matches({ start: event.start, type: 'legends' }));

    return backwardFilterBlockDrugs;
  }

  public handleEvent(events, newstart, blockdrugs, eventsbyday, velcBeforeEvent, darzBeforeEvent, rangeEvents, event,
     drugs, splitdose, startDate) {

    let velcdiff, darzdiff;
    let velcbeforeeventsdiff, darzbeforeeventsdiff;
    const d = lodash.filter(rangeEvents, lodash.matches({ title: 'Darzalex ®' }));
    const v = lodash.filter(rangeEvents, lodash.matches({ title: 'Velcade ®' }));
    const sameEvents = eventsbyday.length;
    const firstEvent = lodash.filter(events, lodash.matches({ type: 'legends' }));
    const firstEventStart = lodash.head(firstEvent)['start'];

    if (rangeEvents.length > 0 && (v.length || d.length)) {
      velcdiff = momenttz(newstart).diff(momenttz(lodash.last(v)['start']), 'days');
      darzdiff = momenttz(newstart).diff(momenttz(lodash.last(d)['start']), 'days');
    }
    if (velcBeforeEvent.length > 0) {
      velcbeforeeventsdiff = momenttz(newstart).diff(momenttz(lodash.last(velcBeforeEvent)['start']), 'days');

    } else {
      velcbeforeeventsdiff = undefined;
    }
    if (darzBeforeEvent.length > 0) {
      darzbeforeeventsdiff = momenttz(newstart).diff(momenttz(lodash.last(darzBeforeEvent)['start']), 'days');
    } else {
      darzbeforeeventsdiff = undefined;
    }
    if (velcBeforeEvent.length > 0 || darzBeforeEvent.length > 0) {
      if (darzBeforeEvent.length > 0) {
        darzbeforeeventsdiff = momenttz(newstart).diff(momenttz(lodash.last(darzBeforeEvent)['start']), 'days');
      }
      if (velcBeforeEvent.length > 0) {
        velcbeforeeventsdiff = momenttz(newstart).diff(momenttz(lodash.last(velcBeforeEvent)['start']), 'days');
      }
    } else {
      velcbeforeeventsdiff = undefined;
      darzbeforeeventsdiff = undefined;
    }
    const velcActualDiff = velcdiff !== undefined ? velcdiff : velcbeforeeventsdiff;
    const darzActualDiff = darzdiff !== undefined ? darzdiff : darzbeforeeventsdiff;



    for (let index = 0; index < events.length; index++) {
      blockdrugs.forEach((bitem) => {
        if (bitem.start === events[index].start) {

          const initialDiff = momenttz(newstart).diff(momenttz(startDate), 'days');
          if (initialDiff >= 0 && firstEventStart.getDate() === events[index]['start'].getDate()) {
            bitem['start'] = newstart;
          } else {
            if (drugs === 'Darz' || drugs === 'DarzMelf' || drugs === 'DarzPred') {
              if (sameEvents === 0 && darzActualDiff !== undefined && darzActualDiff >= 7) {
                bitem['start'] = newstart;
              } else {
                bitem['start'] = event.start;
              }
            } else if (drugs === 'Velc') {
              if (sameEvents === 0 && velcActualDiff !== undefined && velcActualDiff >= 3) {
                bitem['start'] = newstart;
              }
            } else if (drugs === 'DarzVelc') {
              if (sameEvents === 0 &&
                 velcActualDiff !== undefined && velcActualDiff >= 3 && darzActualDiff !== undefined && darzActualDiff >= 7) {
                bitem['start'] = newstart;
              } else if (sameEvents === 0 && velcActualDiff === undefined && darzActualDiff !== undefined && darzActualDiff >= 7) {
                bitem['start'] = newstart;
              } else if (sameEvents === 0 && velcActualDiff !== undefined && velcActualDiff >= 3 && darzActualDiff === undefined) {
                bitem['start'] = newstart;
              }
            } else if (drugs === 'DarzVelcMelfPred') {
              if (sameEvents === 0 && velcActualDiff !== undefined && velcActualDiff >= 3 && darzActualDiff !== undefined &&
                 darzActualDiff >= 7) {
                bitem['start'] = newstart;
              } else if (sameEvents === 0 && velcActualDiff === undefined && darzActualDiff !== undefined && darzActualDiff >= 7) {
                bitem['start'] = newstart;
              } else if (sameEvents === 0 && velcActualDiff !== undefined && velcActualDiff >= 3 && darzActualDiff === undefined) {
                bitem['start'] = newstart;
              }

            } else if ((drugs === 'DarzVelcdexa') || (drugs === 'DarzVelcMelf') || (drugs === 'DarzVelcPred')) {
              if (sameEvents === 0 && velcActualDiff !== undefined && velcActualDiff >= 3 && darzActualDiff !== undefined &&
                 darzActualDiff >= 7) {
                bitem['start'] = newstart;
              } else if (sameEvents === 0 && velcActualDiff === undefined && darzActualDiff !== undefined && darzActualDiff >= 7) {
                bitem['start'] = newstart;
              } else if (sameEvents === 0 && velcActualDiff !== undefined && velcActualDiff >= 3 && darzActualDiff === undefined) {
                bitem['start'] = newstart;
              }

            } else if ((drugs === 'Darzlenadexa') || (drugs === 'DarzMelfPred') || (drugs === 'Darzdexa')) {
              if (sameEvents === 0 && darzActualDiff !== undefined && darzActualDiff >= 7) {
                bitem['start'] = newstart;
              }

            } else if ((drugs === 'Velcdexa') || (drugs === 'VelcMelfPred') || (drugs === 'VelcMelf') || (drugs === 'VelcPred')) {
              if (sameEvents === 0 && velcActualDiff !== undefined && velcActualDiff >= 3) {
                bitem['start'] = newstart;
              }
            } else {
              bitem['start'] = event.start;
            }
          }
        }

      });
    }
    return events;

  }



}
